import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "text-primary-blue ms-1"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "text-primary-blue ms-1"
}
const _hoisted_8 = ["href"]

import conditionsUrl from "../../../computed/conditionsUrl"


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  props: {
    isToolTip: { type: Boolean, default: false }
  },
  setup(__props: any) {

// Imported copmuted
const props = __props

const content = window.content

return (_ctx: any,_cache: any) => {
  return (props.isToolTip)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("a", {
          href: _unref(conditionsUrl),
          target: "_blank",
          class: "text-primary-blue text-decoration-underline",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_unref(content).tooltip_terms_and_conditions_1), 9, _hoisted_2),
        (_unref(content).tooltip_terms_and_conditions_2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(content).tooltip_terms_and_conditions_2), 1))
          : _createCommentVNode("", true),
        (_unref(content).tooltip_terms_and_conditions_3)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _unref(conditionsUrl),
              target: "_blank",
              class: "text-primary-blue text-decoration-underline",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, _toDisplayString(_unref(content).tooltip_terms_and_conditions_3), 9, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_5, [
        _createElementVNode("a", {
          href: _unref(conditionsUrl),
          target: "_blank",
          class: "text-primary-blue text-decoration-underline",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, _toDisplayString(_unref(content).terms_and_conditions_1), 9, _hoisted_6),
        (_unref(content).terms_and_conditions_2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(content).terms_and_conditions_2), 1))
          : _createCommentVNode("", true),
        (_unref(content).terms_and_conditions_3)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _unref(conditionsUrl),
              target: "_blank",
              class: "text-primary-blue text-decoration-underline",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, _toDisplayString(_unref(content).terms_and_conditions_3), 9, _hoisted_8))
          : _createCommentVNode("", true)
      ]))
}
}

})